<template>
  <div :class="[justifyClass, wrapClass]" class="flex items-center">
    <slot />
  </div>
</template>

<script>
const justifyClasses = {
  fill: 'justify-between',
  center: 'justify-center',
  around: 'justify-around',
  left: 'justify-start'
}

const wrapClasses = {
  true: 'flex-wrap'
}

export default {
  props: ['justify', 'wrap'],
  computed: {
    justifyClass() {
      return justifyClasses[this.justify]
    },
    wrapClass() {
      return wrapClasses[this.wrap]
    }
  }
}
</script>
